/* eslint-disable quotes */
import { snakelize, camelize } from "../../../helpers/object";

export default ($axios: any): any => ({
    // 장바구니 리스트
    async index(data: any) {
        return camelize(await $axios.get(`/cart`, { params: snakelize(data) }));
    },

    // 장바구니 상품 등록
    async store(data: any) {
        return camelize(await $axios.post("/cart", snakelize(data)));
    },

    // 장바구니 상품 삭제
    async delete(data: any) {
        return camelize(
            await $axios.delete("/cart", snakelize({ params: data }))
        );
    },

    // 반납, 수령 예정일 조회
    async getSchedules(data: any) {
        return camelize(
            await $axios.get("/cart/rental_dt", { params: snakelize(data) })
        );
    },
});
